import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-mdnusers-list',
  templateUrl: './mdnusers-list.component.html',
  styleUrls: ['./mdnusers-list.component.css']
})
export class MdnusersListComponent implements OnInit {
  selectedUser: IMDNUser;
  users: IMDNUser[];

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    var url = baseUrl + 'api/clients';

    http.get<IMDNUser[]>(url).subscribe(result => {
        this.users = result;
      },
      error => console.error(error));
  }

  onSelect(user: IMDNUser) {
    this.selectedUser = user;
    console.log("user with Id " + this.selectedUser.id + " has been selected");
  }

  ngOnInit() {
  }

}
